exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._3-Rlp{padding-right:20px}._3Y37Q{border-radius:0;width:100%;display:block;font-size:14px;line-height:1.43;color:#484848}._12EZO{font-size:16px;font-weight:700;color:#484848}._2D1A2{font-size:14px;font-weight:400;color:#484848}._3fJn-{text-align:center}.arVqH{border-color:#ff7e82;background-color:#ff7e82;color:#fff;font-size:14px;font-weight:700}.arVqH:hover{background:rgba(54,50,119,.8)}.arVqH:focus{border-color:#0074c2;box-shadow:0 0 8px rgba(0,116,194,.6)}._2EnBK{border-color:#ff5a5f;background-color:#ff5a5f;color:#fff}._1HGXf{padding:7px 21px}._2EnBK:active,._2EnBK:active:focus,._2EnBK:active:hover,._2EnBK:focus,._2EnBK:hover{border-color:#ff7e82;background-color:#ff7e82;color:#fff}._3miwl{border-color:#ff5a5f;color:#ff5a5f;background-color:#fff}._3miwl:active,._3miwl:active:focus,._3miwl:active:hover,._3miwl:focus,._3miwl:hover{border-color:#ff7e82;color:#ff7e82;background-color:#fff}._1yR16{margin-bottom:18px}._1YGTn{margin-bottom:24px}.yvS-7{margin-top:24px}._1v686{margin-top:12px}.KBDRL{margin-bottom:6px}._3uLkc{margin-bottom:12px}._20_zj{padding:0}", ""]);

// exports
exports.locals = {
	"panelSpace": "_3-Rlp",
	"panelEmpty": "_3Y37Q",
	"nolistTitle": "_12EZO",
	"noResults": "_2D1A2",
	"textCenter": "_3fJn-",
	"button": "arVqH",
	"btnPrimary": "_2EnBK",
	"btnlarge": "_1HGXf",
	"btnPrimaryBorder": "_3miwl",
	"space3": "_1yR16",
	"space4": "_1YGTn",
	"spaceTop4": "yvS-7",
	"spaceTop2": "_1v686",
	"space1": "KBDRL",
	"space2": "_3uLkc",
	"noPadding": "_20_zj"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./~/postcss-loader?{"config":"./tools/postcss.config.js"}!./src/components/Reservation/NoItem/NoItem.css
// module id = 2560
// module chunks = 15